import { createFeatureSelector, createSelector } from '@ngrx/store';
import { GetAllDealStatsState } from './get-all-deal-stats.types';
import { DealStageStatus } from '../../../models/deal-stage';
import { groupBy } from 'lodash';

const getAllDealStatsFeatureSelector = createFeatureSelector<GetAllDealStatsState>('getAllDealStats');

export const selectGetAllDealStatsLoading = createSelector(
  getAllDealStatsFeatureSelector,
  state => state.loading
);

export const selectGetAllDealStatsLoaded = createSelector(
  getAllDealStatsFeatureSelector,
  state => state.loaded
);

export const selectGetAllDealStats = createSelector(
  getAllDealStatsFeatureSelector,
  state => state.data
);

export const selectGetAllDealStatsByStageStatus = (status: DealStageStatus) => createSelector(
  getAllDealStatsFeatureSelector,
  state => state.data?.byStageStatus.find(s => s.status === status),
);

export const selectGetAllDealStatsStageMap = createSelector(
  getAllDealStatsFeatureSelector,
  state => groupBy(state.data?.byStage, '_id'),
);

export const selectGetAllDealStatsError = createSelector(
  getAllDealStatsFeatureSelector,
  state => state.error
);
